// @ts-nocheck
/* eslint-disable */
export const appChevronRight20Icon = {
    data: `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.08711 5L6.91211 6.175L10.7288 10L6.91211 13.825L8.08711 15L13.0871 10L8.08711 5Z" fill="currentColor"/></svg>`,
    name: 'chevron-right-20' as const
};